module.exports = __webpack_public_path__ + "media/images/icon_yamori-5711168694604b7738c2413d10a63907.svg";